import { Injectable } from '@angular/core';
import { TemplateStore } from './template.store';
import { TemplateQuery } from './template.query';
import { BaseFacade } from "../base/base.facade";
import { TemplateService } from './template.service';
import { TranslateService } from '@ngx-translate/core';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TemplateModel } from './template.model';

@Injectable({ providedIn: 'root' })
export class TemplateFacade extends BaseFacade {

  constructor(
    templateService: TemplateService,
    templateStore: TemplateStore,
    templateQuery: TemplateQuery,
    dynamicSchemaFacto: DynamicSchemaFactory,
    translateService: TranslateService) {
    super(templateService,
      templateStore,
      templateQuery,
      dynamicSchemaFacto.getDynamicSchemaFacade('template'),
      translateService,
      'template-facade'
      );
  }


  getTemplatesByCategory(category: string): Observable<TemplateModel[]> {
    return (this.getService() as TemplateService).getByCategory(category)
      .pipe(map(list => list.items));
  }

}
